export default __webpack_public_path__ + "static/media/yellow-bell-icon.b4286e81.svg";